import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, ModalModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';
import { MyBookingSubHeaderComponent } from './my-booking-sub-header.component';
import { MyBookingServiceService } from '@common/services/my-booking/my-booking-service/my-booking-service.service';
import { AllSiteDirectiveModule } from '@lib/directives';

@NgModule({
  declarations: [MyBookingSubHeaderComponent],
  imports: [CommonModule, ButtonModule, StaticMsgModule, ModalModule, AllSiteDirectiveModule],
  exports: [MyBookingSubHeaderComponent],
  providers: [MyBookingServiceService],
})
export class MyBookingSubHeaderModule {}
